<template>
    <div class="animated fadeIn">
  
      
      <b-card class="card-accent-info" header="Setor / Área">
        <b-card-body>
  
          <b-row>
            <b-col cols="auto" class="mr-auto">
                <!--
                <b-form-group>
                    <b-button variant="outline-primary" :pressed.sync="tableSelectable">{{tableSelectable ? 'Desabilitar Seleção ' : 'Habilitar Seleção'}}</b-button>
                    &nbsp;
                    <b-button variant="outline-primary" v-show="tableSelectable" @click="selectAllRows">Selecionar todos</b-button>
                    &nbsp;
                    <b-button variant="outline-primary" v-show="tableSelectable" @click="clearSelectedRows">Limpar seleção</b-button>
              </b-form-group>
              -->
            </b-col>
            <b-col cols="auto" class="">
              <b-form-group>
                <!--
                <b-button variant="vine" class="mr-1 btn-brand" @click="enableDisable()"  v-show="tableSelectable"><i class="fa fa-toggle-on"></i><span>Alterar Status</span></b-button>
                &nbsp;
                -->
                <b-button variant="github" class="mr-1 btn-brand" @click="openEditModal(null)"><i class="fa fa-plus"></i><span>Novo Setor</span></b-button>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="auto">
              <b-form-group>
                  <label for="company" style="font-size: 0.8em">Empresa</label>
                  <b-form-select id="company"
                    v-model="filters.companyId"
                    :plain="true"
                    :options="companyDDL"
                    @change="changeCompany"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>

            <b-col cols="auto">
              <b-form-group>
                  <label for="company" style="font-size: 0.8em">Inventário</label>
                  <b-form-select id="inventory"
                    v-model="filters.inventoryId"
                    :plain="true"
                    :options="selectInventoryDDL"
                    @change="refreshData"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>

            <b-col cols="auto">
              <b-form-group>
                  <label for="name" style="font-size: 0.8em">Filtro</label>
                  <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
              </b-form-group>
            </b-col>
        
          <b-col cols="auto">
              <b-form-group>
                  <label for="status" style="font-size: 0.8em">Status</label>
                  <b-form-select id="status"
                    v-model="filters.status"
                    :plain="true"
                    :options="statusddl"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>

            <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
              <b-form-group>
                <p></p>
                <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
              </b-form-group>
            </b-col>

            <b-col cols="auto" class="">
              <b-form-group >
                  <label for="perPage">Linhas</label>
                  <b-form-select v-model="perPage" id="perPage"
                    :plain="true"
                    :options="[5,10,20,50]">
                  </b-form-select>
                </b-form-group>
            </b-col>
            
          </b-row>
        
  
            <b-table
                :items="filteredItems"
                :fields="fields"
                :select-mode="selectMode"
                responsive="sm"
                ref="selectableTable"
                selectable
                @row-selected="onRowSelected"
                :primary-key="primaryKey"
                :tbody-transition-props="transProps"
                sort-icon-left
                @row-clicked="rowClicked"
                :per-page="perPage"
                :current-page="currentPage"
                :busy="isBusy"
                hover
                striped
  
                >
  
                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Carregando...</strong>
                    </div>
                </template>
                
                <!-- Example scoped slot for select state illustrative purposes -->
                <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                    </template>
                </template>
  
                <template #cell(show_details)="row">
                    <b-row>
                        <b-col cols="auto" class="mr-auto">
                            <b-form-group>
                            <b-button size="sm" variant="dark"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </template>
                
                <template #row-details="row">
                    <b-card>
                        <b-row v-show="row.item.summary && row.item.summary.length > 0">
                            <b-col class="small">Resumo</b-col>
                        </b-row>
                        <b-row>
                            <b-col class="text-primary">{{ row.item.summary }}</b-col>
                        </b-row>
                        <b-row v-show="row.item.content && row.item.content.length > 0">
                            <b-col class="small">Conteúdo</b-col>
                        </b-row>
                        <b-row>
                            <b-col class="text-primary">{{ row.item.content }}</b-col>
                        </b-row>
                        <b-row>
                            <b-col>{{ row.item.content }}</b-col>
                        </b-row>
                        <b-row>
                            <b-col><i>Publicado em <b>{{ row.item.publishedin }}</b> por <b>{{ row.item.publisher }}</b></i></b-col>
                        </b-row>
                    </b-card>
                </template>
                
                <template v-slot:cell(originalValue)="data">
                    {{ !isNaN(data.item.originalValue) ? new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format( data.item.originalValue) : '' }}
                </template>

                <template v-slot:cell(paymentValue)="data">
                    {{ !isNaN(data.item.paymentValue) ? new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format( data.item.paymentValue) : '' }}
                </template>

                <template v-slot:cell(costcenter)="data">
                    {{ data.item.costCenterCode  }}<br>{{ data.item.costCenterName }}
                </template>

                <template v-slot:cell(st)="data">
                    <c-switch class="" @change.native="changeStatus(data.item)" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>
                
                <template v-slot:cell(ispublic)="data">
                    <c-switch class="" color="primary" :checked="data.item.ispublic==1" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>
                
                <template v-slot:cell(labels)="data">
                    <div v-show="data.item.labels">
                      <div v-for="item in data.item.labels" :key="item.id">{{ item.labelStart }}-{{ item.labelEnd }}</div>
                    </div>                    
                </template>

            </b-table>
            <nav>
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Próximo" />
            </nav>
  
  
        </b-card-body>
     </b-card>
  
  
     <b-modal
              v-model="editModal"
              id="edit-modal"
              centered
              hide-footer
              title="Setor"
              size="lg">
  
        <b-nav fill>
          <b-nav-item :active="tabInfo=='S'" @click="tabInfo='S'">Setor / Área</b-nav-item>
          <b-nav-item :active="tabInfo=='L'" @click="tabInfo='L'">Etiquetas</b-nav-item>
        </b-nav>

        <div v-show="tabInfo=='L'">
          <b-card>
            <inventory-sector-label
              :inventoryDDL="inventoryDDL"
              :inventoryId="Number(filters.inventoryId)"
              :companyId="Number(filters.companyId)"
              :stockLocationId="Number(selectedItem.id)"
            ></inventory-sector-label>
          </b-card>
        </div>

        <div v-show="tabInfo=='S'">
          <b-card style="min-height: 200px">

            <b-form @submit.stop.prevent="onSubmit">
              
              <div class="animated fadeIn">

                <b-row>
                  <b-col md="12">
                    <b-form>
                      <b-form-group
                      description=""
                      label="Sigla"
                      label-for="name"
                      :label-cols="3"
                      :horizontal="true">
                      <b-form-input v-model="selectedItem.name" id="name" type="text" style="text-transform: uppercase" ></b-form-input>
                    </b-form-group>          
                    </b-form>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col md="12">
                    <b-form>
                      <b-form-group
                      description=""
                      label="Área"
                      label-for="areaCode"
                      :label-cols="3"
                      :horizontal="true">
                      <b-form-input v-model="selectedItem.areaCode" id="areaCode" type="text" style="text-transform: uppercase" ></b-form-input>
                    </b-form-group>          
                    </b-form>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col md="12">
                    <b-form>
                      <b-form-group
                      description=""
                      label="Nro"
                      label-for="nro"
                      :label-cols="3"
                      :horizontal="true">
                      <b-form-input v-model="selectedItem.nro" id="nro" type="number"  ></b-form-input>
                    </b-form-group>          
                    </b-form>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col md="12">
                    <b-form>
                      <b-form-group
                      description=""
                      label="Próprio"
                      label-for="code"
                      :label-cols="3"
                      :horizontal="true">
                      <b-form-input v-model="selectedItem.code" id="code" type="text" style="text-transform: uppercase" ></b-form-input>
                    </b-form-group>          
                    </b-form>
                  </b-col>
                </b-row>


                <b-input-group class="mb-4">
                    <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
                </b-input-group>
              
                <div slot="footer" class="text-right">
                  <!--
                  <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='I'"><i class="fa fa-times"></i><span>Habilitar</span></b-button>
                  <b-button variant="html5" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='A'"><i class="fa fa-times"></i><span>Desabilitar</span></b-button>
                  -->
                  <b-button variant="github" class="mr-1 btn-brand" @click="save()"><i class="fa fa-check"></i><span>Salvar Setor</span></b-button>
                
                </div>
                      
              </div>
            </b-form>

          </b-card>
        </div>
  
      </b-modal>
  
    </div>
  
  </template>
  
  <script>
  import Vue from 'vue'
  import axios from "axios";
  
  import { Switch as cSwitch } from '@coreui/vue'
  
  /* Toast */
  import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  import InventorySectorLabel from './InventorySectorLabel'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */
  
  const newItem = {id: null, name: '', description: '', st: 'A', _rowVariant: ''}
  
  export default {
    name: 'tables',
    components: {
      Event,
      cSwitch,
      InventorySectorLabel
    },
    data: () => {
      return {
        tabInfo: 'S',
        statusddl: [
          {
            text: '- Todos -',
            value: 0
          },
          {
            text: 'Ativo',
            value: 'A'
          },
          {
            text: 'Inativo',
            value: 'I'
          }
        ],
        companyDDL: [],
        inventoryDDL: [],

        isBusy: false,
        currentPage: 1,
        switchLabelIcon: {
            dataOn: '\u2713',
            dataOff: '\u2715'
        },
        switchLabelTxt: {
            dataOn: 'yes',
            dataOff: 'no'
        },
  
        tableRef: "table",
        tableSelectable: false,
        errorMessage: '',
        editModal: false,
        filters: {
          companyId: null,
          key: '',
          status: 0,
          inventoryDDL: 0,
          inventoryId: 0
        },
  
        modes: ['multi', 'single', 'range'],
        selectMode: 'multi',
        selected: [],
        transProps: {
          // Transition name
          name: 'flip-list'
        },
        primaryKey: "id",
  
        selectedItem: newItem,
        items: [        
        ],
        fields: [
          //{key: 'show_details', label: "", thStyle: { width: "40px" } },
          //{key: 'id' },
          //{key: 'costcenter', label: 'Centro de Custo', sortable: true, thStyle: { width: "200px" }  },
          {key: 'name', label: 'Sigla', sortable: true, thStyle: { width: "100px" } },
          {key: 'areaCode', label: 'Área', sortable: true, thStyle: { width: "100px" } },
          {key: 'nro', label: 'Nro', sortable: true, thStyle: { width: "100px" } },
          {key: 'code', label: 'Próprio', sortable: true },
          {key: 'labels', label: 'Etiquetas', sortable: true, thStyle: { width: "120px" }, class: 'text-center' },
          {key: 'st', label: 'Status', sortable: true, thStyle: { width: "40px" } }
        ],
        
        filterable: ['username'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        perPage: 20
      }
    },
    computed: {
      totalRows: function () { return this.getRowCount() },
      filteredItems() {
        try {
            return this.items.filter(item => {
              return (this.filters.key == '' || (
                  this.$utils.filterString(item.name, this.filters.key)
                  //(item.name != null && item.name.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                  //|| (item.username != null && item.username.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                  //|| (item.email != null && item.email.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                  ))
                  && (this.filters.status==0 || (this.filters.status == 'A' || this.filters.status == 'I') && item.st == this.filters.status )                  
            })
        }
        catch(e) {
            return this.items;
        }
      },
      selectInventoryDDL: function() {
        var list = [...this.inventoryDDL]
        list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
        list.unshift({ value: '0' , text: '-' })
        return list
      },

    },
    methods: {

      getRowCount: function () {
        if(this.items)
            return this.items.length
        else
            return 0;
      },
     
      changeStatus(item) {
        if(item != null) {
          if(item.st == 'A') 
            item.st = 'I'; 
          else 
            item.st = 'A';
          this.saveItem(item);
        }
      },

      async saveItem(currentItem) {

        var s = this;
        var postData = {...currentItem};

        postData["companyId"] = s.filters.companyId
        postData["uid"] = this.$store.state.currentUser.id,
        postData["sid"] = this.$store.state.currentUser.sid

        await axios.post(
            this.$store.state.ws_url + "/stock/location",
            postData
        ).then(function() {
            s.closeEditModal()
            s.refreshData();
        }
        ).catch(function (error) {
           
            toast ({
                type: VueNotifications.types.warn,
                title: 'Setor',
                message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
                timeout: 5000
            })        
        });

    },

    save() {

        let msgError = [];

        if(this.selectedItem.name.length <= 2)
            msgError.push("Sigla");
        
        if(msgError.length > 0) {
            let msgErrorExt = "Verifique os campos: ";
            let msgErrorSep = "";
            msgError.forEach(function(element) { msgErrorExt += msgErrorSep + element; msgErrorSep=", "; } )

            toast ({
                type: VueNotifications.types.error,
                title: 'Setor',
                message: msgErrorExt,
                timeout: 5000
            })
        }
        else {
            this.saveItem(this.selectedItem);
        }
    },

      enableDisable() {
        console.log('Habilitando/desabilitando modelo')
        console.log(this.selectedItem);
      },
      closeEditModal() {
        this.editModal = false;
      },
      openEditModal(item) {
        this.tabInfo = 'S'
        if(item == null) {
            this.selectedItem = { ...newItem };      
        }
        else {
            this.selectedItem = { ...item };
        }
        this.editModal = true;
      },
      onRowSelected(items) {
        this.selected = items       
      },
      selectAllRows() {
        this.$refs.selectableTable.selectAllRows();
      },
      clearSelectedRows() {
        this.$refs.selectableTable.clearSelected();
      },
      rowClicked(item) {
        if(!this.tableSelectable) {
            this.clearSelectedRows();
            this.openEditModal(item);
        }
      },
      getBadge (status) {
        return status === 'A' ? 'primary'
            : status === 'I' ? 'danger'
            : status === 'Pending' ? 'warning'
                : status === 'Banned' ? 'danger' : 'primary'
      },
      async refreshData() {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        this.isBusy = true;

        this.$utils.setInventoryContext(this.$store.state.config.storageName, this.filters.companyId, this.filters.inventoryId)


        await axios.get(
            this.$store.state.ws_url + "/stock/location?companyId=" + s.filters.companyId + "&inventoryId=" + s.filters.inventoryId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
        ).then(function (resp) {
            s.items = resp.data.obj;
        }
        ).catch(function (error) {
             console.log(error.message);
            toast ({
                type: VueNotifications.types.error,
                title: 'Setor',
                message: 'Sem permissão de acesso. Verifique e tente novamente.',
                timeout: 3000
            })
        });

        this.isBusy = false;
        
      },
      
      async getInventory() {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        
        await axios.get(
            this.$store.state.ws_url + "/stock/inventory/ddl?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
        ).then(function(resp) {
            s.inventoryDDL = resp.data.obj;
            if(s.inventoryDDL && s.inventoryDDL.length > 0) {
              if(!s.filters.inventoryId || s.filters.inventoryId <= 0 || !s.inventoryDDL.some(i => i.value == s.filters.inventoryId)) {
                s.filters.inventoryId = Number(s.inventoryDDL[s.inventoryDDL.length-1].value)
              }
            }
            s.$utils.setInventoryContext(s.$store.state.config.storageName, s.filters.companyId, s.filters.inventoryId)
        })
        .catch(function(error) {
            console.log(error);
        });
        this.refreshData();
      },

      changeCompany() {
        this.filters.inventoryId = 0
        this.getInventory()
        this.refreshData()
      }

    },
    mounted: function() {
      this.companyDDL = this.$store.state.currentUser.companies

      var stored = this.$utils.getInventoryContext(this.$store.state.config.storageName)
      var validStoredCompany = stored && stored.companyId && this.companyDDL.some(c => c.value == stored.companyId)

      this.filters.companyId = validStoredCompany ? stored.companyId : this.$store.state.currentUser.companyId
      if(validStoredCompany && stored.inventoryId) {
        this.filters.inventoryId = stored.inventoryId
      }

      this.changeCompany()
    }
  }
  </script>
  
  <style scoped>
  table#table-transition-example .flip-list-move {
  transition: transform 1s;
  }
  </style>